export const ACCOUNT_FEATURES = {
  // Deprecated
  ADMIN_ALLOW_API_KEY: "admin_allow_api_key",
  // Active
  ADMIN_ALLOW_ACCESS_KEY_V2: "admin_allow_access_key_v2",
  ADMIN_ALLOW_HOLIDAYS: "admin_allow_holidays",
  ADMIN_ALLOW_DEFAULT_WORKSCHEDULE: "admin_allow_default_workschedule",
  ADMIN_ALLOW_LOGIN_ENFORCEMENT: "admin_allow_login_enforcement",
  ADMIN_ALLOW_USER_GROUPS: "admin_allow_user_groups",
  ADMIN_ALLOW_GOOGLE_SYNC: "admin_allow_google_sync",
  ADMIN_ALLOW_USER_MODEL_EXTENSION: "admin_allow_user_model_extension",
  ADMIN_ALLOW_REMOTE_LOGOUT: "admin_allow_remote_logout",
  ADMIN_ALLOW_O365_LOGIN: "admin_allow_o365_login",
  ADMIN_ALLOW_SAML: "admin_allow_saml",
  ADMIN_ALLOW_SCIM_SYNC: "admin_allow_scim_sync",
  ADMIN_ALLOW_DIRECTORY_SYNC: "admin_allow_directory_sync",
  ADMIN_ALLOW_2FA: "admin_allow_2fa",
  PROJECT_ALLOW_PROJECT_MODULE: "project_allow_project_module",
  CASE_ALLOW_CASE_MODULE: "case_allow_case_module",
  PROCESS_ALLOW_PROCESS_MODULE: "process_allow_process_module",
  ADMIN_ALLOW_MEMBERS_MANAGEMENT: "admin_allow_member_management",
  INTEGRATION_ALLOW_INTEGRATION_MODULE: "integration_allow_integration_module",
  ADMIN_ALLOW_GOOGLE_LOGIN: "admin_allow_google_login",
  DATASET_ALLOW_DATASET_MODULE: "dataset_allow_dataset_module",
  ADMIN_ALLOW_LOGIN_AUDIT: "admin_allow_login_audit",
  ADMIN_ALLOW_MOBILE_BRANDING: "admin_allow_mobile_branding",
  ADMIN_ALLOW_DOWNLOAD_CUSTOMIZE: "admin_allow_download_customize",
  ADMIN_ALLOW_PRINT_CUSTOMIZE: "admin_allow_print_customize",
  ADMIN_ALLOW_EMAIL_APPROVAL: "admin_allow_emailapproval_customize",
  ADMIN_ALLOW_CUSTOM_THEME: "admin_allow_custom_theme",
  ADMIN_ALLOW_FLOWCREATION_CONTROL: "admin_allow_flowcreation_control",
  ADMIN_ALLOW_FLOWCREATION_SUPERADMIN: "admin_allow_flowcreation_superadmin",
  ADMIN_ALLOW_FLOWCREATION_APPROVERS: "admin_allow_flowcreation_approvers",
  ADMIN_ALLOW_SELF_SIGNUP: "admin_allow_self_signup",
  ADMIN_ALLOW_TASK_DELEGATION: "admin_allow_task_delegation",
  AUDIT_ALLOW_ACCOUNT_LEVEL_LOGGING: "audit_allow_account_level_logging",
  ADMIN_ALLOW_GEOLOCATION: "admin_allow_geolocation_field",
  ADMIN_ALLOW_DELEGATION: "admin_allow_admin_taskdelegation",
  ADMIN_ALLOW_NOTIFICATION_SETTINGS: "admin_allow_notification_settings",
  ADMIN_ALLOW_ACCOUNT_BACKUP: "admin_allow_account_backup",
  ADMIN_ALLOW_DOMAIN_CUSTOMIZATION: "admin_allow_domain_customization",
  ADMIN_ALLOW_AI_CHAT: "admin_allow_ai_chat",
  PORTAL_ALLOW_DOMAIN_CUSTOMIZATION: "portal_allow_domain_customization",
  PLATFORM_ALLOW_BILLING_SECTION: "platform_allow_billing_section"
};
